module.exports = __webpack_public_path__ + "images/emoji/fishing_pole_and_fish.de24702e2cc120fb938c.png";